module.exports = __webpack_public_path__ + "3f3a5139ff67bcc8c23fac3018785ba2.svg";